
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal-wide",
      function () {
        return require("private-next-pages/portal-wide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal-wide"])
      });
    }
  